export const TVI_SETTINGS = "tviSettings";

export const fundSourceTviOptions = [
  {
    label: "Senate",
    value: "Senate",
  },
  {
    label: "Agency",
    value: "Agency",
  },
];

export const acceptedFileTypes = [
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/pdf",
];

export const selectorOptions = [
  {
    value: 0,
    label: "Congressman",
  },
  {
    value: 1,
    label: "Senator",
  },
  {
    value: 2,
    label: "Governor",
  },
  {
    value: 3,
    label: "Vice Governor",
  },
  {
    value: 4,
    label: "Mayor",
  },
  {
    value: 5,
    label: "Vice Mayor",
  },
  {
    value: 6,
    label: "Others",
  },
];
